import { EditorView } from "@codemirror/view";

export const theme = EditorView.theme({
  "&": {
    fontSize: "0.9rem",
    fontFamily: "Roboto Mono, monospace",
    color: "#686966",
  },
  ".cm-scroller": {
    fontFamily: "Roboto Mono, monospace",
  },
  ".cm-line": {
    padding: "8px",
  },
  ".cm-activeLine": {
    backgroundColor: "transparent !important",
  },
  ".cm-tooltip.cm-tooltip-autocomplete": {
    top: "100% !important", // Position the dropdown below the input
    left: "4px !important", // Align it to the left of the input
    marginTop: "3px", // Add some spacing
    transform: "none",
    border: "1px solid #ccc",
    borderTop: "none",
    backgroundColor: "#fff",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    zIndex: "1000",

    "& > ul": {
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,

      "& > li > .cm-completionIcon": {
        display: "none",
      },
      "& > li, & > completion-section": {
        padding: "8px 8px",
        marginRight: "0.5rem",
        lineHeight: 1.2,
        backgroundColor: "transparent",
      },
      "& > li > .cm-completionLabel": {
        color: "#bb4d00",
        paddingLeft: "0.75rem",
        paddingRight: "0.75rem",
        paddingBottom: "0.25rem",
        paddingTop: "0.25rem",
        borderRadius: "20rem",
        backgroundColor: "#fef3c6",
      },
      "& > li:hover > .cm-completionLabel": {
        backgroundColor: "#fee685",
      },

      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer",
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7,
      },
    },
  },
});

export const attributes = EditorView.editorAttributes.of({
  class:
    "cursor-text rounded-lg border border-tone-500 outline-none [&.cm-focused]:outline-none pr-16",
});
